import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import FontInput from "./font_input";


class TextDropdown extends React.Component {
  state = {
    value: this.props.frame.value,
    fontSize: null
  }

  componentDidMount() {
    this.setValue(); // Respect pagination updates
  }

  setValue = () => {
    const { textFrameData, frame } = this.props;
    if (textFrameData[frame.id] && textFrameData[frame.id].value) {
      this.setState({ value: textFrameData[frame.id].value });
    }
  }

  triggerFrameUpdate = () => {
    const { frame, updateFrameData } = this.props;
    const { value, fontSize } = this.state;
    updateFrameData({ [frame.id]: { value, font_size: fontSize } });
  }

  handleValueChange = (value) => {
    this.setState({ value }, () => {
      this.triggerFrameUpdate();
    });
  }

  updateFontSize = (fontSize) => {
    this.setState({ fontSize: parseInt(fontSize, 10) }, () => {
      this.triggerFrameUpdate();
    });
  }

  formattedOptions = () => (
    Object.values(this.props.options).map((value) => (
      { value, label: value }
    ))
  );

  render() {
    const { frame, fontSettings, templateSettings } = this.props;
    const { value } = this.state;
    return (
      <React.Fragment>
        <div className="input-headers">
          <label htmlFor={frame.id}>
            {frame.name === "$ID/" ? "" : frame.name}
          </label>
          <FontInput
            frame={frame}
            updateFontSize={this.updateFontSize}
            fontSettings={fontSettings}
            templateSettings={templateSettings}
          />
        </div>
        <Select
          className="text-dropdown-select"
          value={value}
          options={this.formattedOptions()}
          clearable={false}
          searchable
          onChange={(option) => this.handleValueChange(option.value)}
        />
      </React.Fragment>
    );
  }
}

TextDropdown.propTypes = {
  frame: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    points: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
  }).isRequired,
  options: PropTypes.shape({
    0: PropTypes.string
  }),
  updateFrameData: PropTypes.func.isRequired,
  fontSettings: PropTypes.shape({}).isRequired,
  templateSettings: PropTypes.shape({
    allowFontSizing: PropTypes.bool
  }).isRequired,
  textFrameData: PropTypes.shape({}),
};

TextDropdown.defaultProps = {
  options: {},
  textFrameData: {}
};

export default TextDropdown;
